import React, { useEffect, useState } from 'react';
import { Router } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import MomentUtils from '@date-io/moment';
import { ThemeProvider } from '@material-ui/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import 'react-perfect-scrollbar/dist/css/styles.css';

import { fetchMe } from './actions';
import routes from './routes';
import { theme } from './theme';
import AuthPersistor from './components/AuthPersistor';
import FreshdeskChat from './components/FreshdeskChat';
import ScrollReset from './components/ScrollReset';
import StylesProvider from './components/StylesProvider';
import { userRoles } from './reducers/sessionReducer';
import ToastProvider from './utils/Toast/ToastProvider';

import './mixins/chartjs';
import './mixins/moment';
import './mixins/validate';
import './mixins/prismjs';
import './mock';
import './assets/scss/main.scss';

const App = ({ history }) => {
  const dispatch = useDispatch();
  const session = useSelector(state => state.session);
  const [direction] = useState('ltr');

  const userType = session?.userType;

  useEffect(() => {
    const fetchSuperStuffs = async () => {
      await dispatch(fetchMe());
    };

    if (userType === userRoles.SUPERADMIN) {
      fetchSuperStuffs();
    }
  }, [userType]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ThemeProvider theme={theme}>
      <StylesProvider direction={direction}>
        <ToastProvider>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <Router history={history}>
              <AuthPersistor>
                <ScrollReset />
                <FreshdeskChat />
                {renderRoutes(routes)}
              </AuthPersistor>
            </Router>
          </MuiPickersUtilsProvider>
        </ToastProvider>
      </StylesProvider>
    </ThemeProvider>
  );
};

export default App;
